import React, { useEffect, useState } from 'react';
import { remoteConfig } from './utilities/Firebase';
import App from './App';

function AppFeatureFlag() {
	// set to anything else to avoid flashing with downside of having to wait for firebase config
	const [enabled, setEnabled] = useState<any>('loading');

	useEffect(() => {
		const getConfig = async () => {
			await remoteConfig.fetchAndActivate();
			const mapSearch: any = await remoteConfig.getConfigBoolean('mapSearch');
			setEnabled(mapSearch);
		};
		getConfig();
	}, []);

	if (enabled === 'loading') {
		return <></>;
	} else if (enabled === true) {
		return <App />;
	} else if (enabled === false) {
		window.location.href = '/500';
	}

	// loading... while waiting for firebase config
	return <div />;
}

export default AppFeatureFlag;
